/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";
import SoftBadge from "components/SoftBadge";
import SoftButton from "components/SoftButton";
import ReceiptDialog from "components/Dialogs/ReceiptDialog";

function Author({ name, username, email }) {
  return (
    <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
      <SoftBox mr={2}>
        <SoftAvatar
          src={`https://ui-avatars.com/api/?name=${name}`}
          alt={name}
          size="sm"
          variant="rounded"
        />
      </SoftBox>
      <SoftBox display="flex" flexDirection="column">
        <SoftTypography variant="button" fontWeight="medium">
          {name} ({username})
        </SoftTypography>
        <SoftTypography variant="caption" color="secondary">
          {email}
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

function Function({ job, org }) {
  return (
    <SoftBox display="flex" flexDirection="column">
      <SoftTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </SoftTypography>
      <SoftTypography variant="caption" color="secondary">
        {org}
      </SoftTypography>
    </SoftBox>
  );
}

const apiUrl = "https://api.getverceipt.com/api/v1";

function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export default function useAuthorsTableData() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = [
    { name: "id", align: "center" },
    { name: "store", align: "left" },
    { name: "issued", align: "center" },
    { name: "action", align: "center" }
  ];

  const [maxStores, setMaxStores] = useState(0);
  const [storeCount, setStoreCount] = useState(0);
  const [viewingReceipt, setViewingReceipt] = useState(null);
  const [receiptOpen, setReceiptOpen] = useState(false);

  const onViewReceipt = async (receipt) => {
    setViewingReceipt(receipt.receipt_data);
    setReceiptOpen(true);
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/receipts/list/recent/50`, {
          method: 'GET',
          withCredentials: true,
          credentials: 'include', // make sure cookies/session are sent
          headers: {
            'Content-Type': 'application/json',
          },
        });        
        if (!response.ok) throw new Error("Network response was not ok");

        const data = await response.json();
        console.log(data)

        const formattedRows = data.map((user) => ({
          id: <SoftTypography variant="caption" color="secondary" fontWeight="medium">{user.id}</SoftTypography>,
          store: <SoftTypography variant="caption" color="secondary" fontWeight="medium">{user.store_address} (id: {user.store_id})</SoftTypography>,
          issued: (
            <SoftTypography variant="caption" color="secondary" fontWeight="medium">
              {formatDate(user.issued_at)}
            </SoftTypography>
          ),
          action: (
            <SoftTypography
              component="a"
              href="#"
              variant="caption"
              color="secondary"
              fontWeight="medium"
              onClick={() => onViewReceipt(user)}
            >
              View
            </SoftTypography>
          ),
        }));

        setRows(formattedRows);
      } catch (error) {
        console.error("Failed to fetch users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const viewReceiptDialog = (
      <ReceiptDialog
        open={receiptOpen}
        onClose={() => setReceiptOpen(false)}
        data={viewingReceipt}
      />
  );

  return { columns, rows, loading, storeCount, maxStores, viewReceiptDialog };
}
